var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:{ mobile: _vm.isMobile }},[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.bannerImage,"alt":_vm.isEnLang ? '2026 Shenzhen International FinTech Competition — WeBank FinTech College Students Challenge' : '2026深圳国际金融科技大赛——微众银行金融科技大学生挑战赛'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }